document.addEventListener('DOMContentLoaded', function () {
  // Select all accordion headings
  const accordionHeadings = document.querySelectorAll('.accordion-block__heading');

  // Loop through each heading and add a click event listener
  accordionHeadings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      // Get the associated content div for the clicked heading
      const content = heading.nextElementSibling;

      // If the content is currently open, close it
      if (content.classList.contains('open')) {
        content.classList.remove('open');
        content.style.maxHeight = null; // Reset height to close it
      } else {
        // Close all other open accordions
        const allContents = document.querySelectorAll('.accordion-block__content');
        allContents.forEach(function (openContent) {
          openContent.classList.remove('open');
          openContent.style.maxHeight = null;
        });

        // Open the clicked accordion
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px'; // Set the height to reveal content
      }
    });
  });
});

var _kl_onSiteForms = _kl_onSiteForms || [];

document.addEventListener("DOMContentLoaded", function() {
  // Grab all buttons with class '.klaviyo-notify-btn'
  var buttons = document.querySelectorAll('.klaviyo-notify-btn');

  // Loop through the buttons and push the form IDs into the _kl_onSiteForms array
  buttons.forEach(function(button) {
    var formId = button.getAttribute('data-form-id');
    
    // Check if the formId is already in the array (to avoid duplicates)
    if (!_kl_onSiteForms.some(function(form) { return form.formId === formId })) {
      _kl_onSiteForms.push({
        formId: formId,
        formType: 'pop-up'
      });
    }
    
    // Add the click event listener to each button
    button.addEventListener('click', function() {
      console.log('event hit, ready to toggle form', formId)
      // Show the Klaviyo form associated with the button's data-form-id
      // window.KlaviyoOnSite.showForm(formId);
    });
  });
});